import React, { useState } from "react";
import { Pencil, Trash2, Plus } from "lucide-react";

const mockData = [
  { id: 1, name: "Abram Schleifer", position: "Sales Assistant", office: "Edinburgh", age: 57, date: "25 Apr, 2027", salary: "$89,500" },
  { id: 2, name: "Charlotte Anderson", position: "Marketing Manager", office: "London", age: 42, date: "12 Mar, 2025", salary: "$105,000" },
  { id: 3, name: "Ethan Brown", position: "Software Engineer", office: "San Francisco", age: 30, date: "01 Jan, 2024", salary: "$120,000" },
  // Ajoute les autres lignes si nécessaire
];

export default function Dh_university() {
  const [search, setSearch] = useState("");
  const [data, setData] = useState(mockData);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const filtered = data.filter(row =>
    row.name.toLowerCase().includes(search.toLowerCase())
  );

  const openModal = (item = null) => {
    setSelectedItem(item);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedItem(null);
  };

  const handleDelete = (id) => {
    setData(data.filter(row => row.id !== id));
  };

  return (
    <div className="p-6  text-white min-h-screen">
      <div className="max-w-7xl dark:bg-gray-800 bg-gray-200 mx-auto  p-6">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-bold">Universitys</h2>
          <button
            onClick={() => openModal()}
            className="flex items-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-500 rounded text-sm font-medium"
          >
            <Plus size={18} /> Ajouter un article
          </button>
        </div>

        {/* Search */}
        <div className="flex justify-end mb-4">
          <input
            type="text"
            placeholder="Search..."
            className="px-3 py-2 bg-gray-800 border border-gray-600 rounded text-sm w-64"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        {/* Table */}
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm">
            <thead className="bg-[#1a253c] text-gray-400 text-left">
              <tr>
                <th className="px-4 py-2">User</th>
                <th className="px-4 py-2">Position</th>
                <th className="px-4 py-2">Office</th>
                <th className="px-4 py-2">Age</th>
                <th className="px-4 py-2">Start Date</th>
                <th className="px-4 py-2">Salary</th>
                <th className="px-4 py-2 text-right">Action</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((row) => (
                <tr key={row.id} className="border-t border-gray-700">
                  <td className="px-4 py-2 font-semibold">{row.name}</td>
                  <td className="px-4 py-2">{row.position}</td>
                  <td className="px-4 py-2">{row.office}</td>
                  <td className="px-4 py-2">{row.age}</td>
                  <td className="px-4 py-2">{row.date}</td>
                  <td className="px-4 py-2">{row.salary}</td>
                  <td className="px-4 py-2 text-right flex justify-end gap-2">
                    <button onClick={() => openModal(row)} className="text-blue-400 hover:text-blue-600">
                      <Pencil size={16} />
                    </button>
                    <button onClick={() => handleDelete(row.id)} className="text-red-400 hover:text-red-600">
                      <Trash2 size={16} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="text-xs text-gray-400 mt-4">
          Showing 1 to {filtered.length} of {data.length} entries
        </p>
      </div>

      {/* Modal */}
      {modalOpen && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center">
          <div className="bg-[#121c31] rounded-lg p-6 w-[90%] max-w-md">
            <h2 className="text-xl font-bold mb-4">
              {selectedItem ? "Modifier l'article" : "Ajouter un article"}
            </h2>

            {/* Form */}
            <form className="space-y-4">
              <input type="text" placeholder="Nom" defaultValue={selectedItem?.name || ""} className="w-full p-2 rounded bg-gray-700 text-white" />
              <input type="text" placeholder="Poste" defaultValue={selectedItem?.position || ""} className="w-full p-2 rounded bg-gray-700 text-white" />
              <input type="text" placeholder="Bureau" defaultValue={selectedItem?.office || ""} className="w-full p-2 rounded bg-gray-700 text-white" />
              <input type="number" placeholder="Âge" defaultValue={selectedItem?.age || ""} className="w-full p-2 rounded bg-gray-700 text-white" />
              <input type="text" placeholder="Date de début" defaultValue={selectedItem?.date || ""} className="w-full p-2 rounded bg-gray-700 text-white" />
              <input type="text" placeholder="Salaire" defaultValue={selectedItem?.salary || ""} className="w-full p-2 rounded bg-gray-700 text-white" />
              <div className="flex justify-between gap-4">
                <button type="submit" className="w-full py-2 bg-blue-600 hover:bg-blue-500 rounded text-white">
                  {selectedItem ? "Modifier" : "Ajouter"}
                </button>
                <button
                  type="button"
                  onClick={closeModal}
                  className="w-full py-2 bg-gray-600 hover:bg-gray-500 rounded text-white"
                >
                  Annuler
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
